<template>
  <div>
    <v-container class="justify-center">
      <v-form @submit.prevent="senddata" ref="form" lazy-validation>
        <v-row align="center">
          <v-col class="d-flex justify-center" cols="12" sm="6">
            <v-select
              label="IP Version"
              v-model="ipversion"
              :items="ipversionlist"
              @change="loadConf"
              outlined
              requried
              :rules="rules.required"
            ></v-select>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-select
              label="Protocol"
              v-model="protocol"
              :items="supportedProtocols"
              requried
              :rules="rules.required"
              outlined
            ></v-select>
          </v-col> </v-row
        ><v-spacer></v-spacer>
        <v-row
          ><v-col
            ><v-chip v-if="authtype === 'USERNAME_PASSWORD'" color="blue"
              >Credentials will be generated automatically.</v-chip
            ></v-col
          > </v-row
        ><v-spacer></v-spacer>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-select
              label="Authentication Type"
              v-model="authtype"
              :items="authlist"
              requried
              :rules="rules.required"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <div v-if="authtype === 'IP_WHITELIST'">
          <v-row
            align="center"
            v-for="(item, index) in parseInt(ipwhitelistnumber)"
            :key="index"
          >
            <v-container v-if="index === 0" fluid>
              <v-btn
                @click="
                  ipwhitelist[index] = clientIP;
                  ipwhitelistnumber++;
                  ipwhitelistnumber--;
                "
                elevation="2"
                >Set to Your current IP: {{ clientIP }}</v-btn
              ></v-container
            >
            <v-col class="d-flex" cols="12" sm="6">
              <v-text-field
                v-model="ipwhitelist[index]"
                :append-outer-icon="item > 1 ? 'mdi-minus' : 'mdi-plus'"
                filled
                clearable
                label="IP Whitelist"
                type="text"
                :rules="rules.ipaddress"
                @click:append-outer="
                  item > 1 ? removeIPWhitelist(index) : addIPWhitelist()
                "
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-spacer></v-spacer>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-text-field
              persistent-hint
              :hint="fieldHint"
              label="Bandwidth [GB]"
              v-model="bandwidth"
              type="number"
              :rules="[rules.minBw, rules.maxBw]"
            ></v-text-field>
          </v-col> </v-row
        ><v-spacer></v-spacer>
        <v-row align="center" v-show="billinglist.length > 1">
          <v-col class="d-flex" cols="12" sm="6">
            <v-select
              label="Billing Cycle"
              v-model="billing"
              :items="billinglist"
              :rules="rules.required"
              outlined
              required
              @input="recalcPrices"
            ></v-select>
          </v-col> </v-row
        ><v-spacer></v-spacer>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <h2>Price: {{ price }}</h2>
          </v-col> </v-row
        ><v-spacer></v-spacer>
        <v-row>
          <v-btn @click="senddata" color="success" block class="mt-2">
            Add To Cart
            <v-icon right dark> mdi-cart </v-icon></v-btn
          ></v-row
        >
      </v-form>
    </v-container>
  </div>
</template>
<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import OrderConfiguration from "../api/OrderConfiguration";
import LangMap from "../LangMap.js";
import Cart from "../api/Cart";
import rules from "@/Libs/rules";
import bwPricesMixin from "@/Libs/bwPricesMixin";

const proxytype = "PROXY_RESIDENTIAL";

export default {
  name: "Residential",
  components: {},
  mixins: [bwPricesMixin],
  data() {
    return {
      ipwhitelist: [],
      ipwhitelistnumber: 1,
      clientIP: "",
    };
  },
  methods: {
    addIPWhitelist() {
      if (this.ipwhitelistnumber < this.supportedIPWhitelistCount) {
        this.ipwhitelistnumber++;
      }
    },
    removeIPWhitelist(item) {
      this.ipwhitelist.splice(item, 1);
      this.ipwhitelistnumber--;
    },
    senddata() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let payload = {
        authenticationType: this.authtype,
        country: this.country,
        ipVersion: this.ipversion,
        proxyProtocol: this.protocol,
        bandwidth: this.bandwidth,
        serviceType: proxytype,
      };
      let config = {
        pid: sessionStorage.getItem("pid"),
        billing: this.billing,
      };
      if (this.authtype === "IP_WHITELIST") {
        payload["ipWhitelist"] = this.ipwhitelist;
      }

      if (this.ipVersion === "IPv6") {
        payload["package"] = this.packages;
      }

      const api = new Cart(this.$axios, { api: payload, config });

      api.addToCart().then((response) => {
        if (response.data.url) {
          window.location.href = "cart.php?" + response.data.url.join("&");
        }
      });
    },
    langMap(obj, key = "") {
      return LangMap(obj, key);
    },
    loadConf() {
      const payload = {
        serviceType: proxytype,
        ipVersion: this.ipversion,
        bandwidth: this.bandwidth,
      };
      const api = new OrderConfiguration(this.$axios, payload);
      api.getConfiguration().then((response) => {
        this.$store.commit("Configuration/SET_CONFIGURATION", response.data);
        this.$store.commit(
          "IPVersion/SET_IPVERLIST",
          response.data.supportedIpVersions
        );
        this.clientIP = response.data.clientIp;
      });
    },
    formatCurrency(price) {
      return (
        this.currency.prefix + "" + price.toFixed(2) + this.currency.suffix
      );
    },
  },
  mounted() {
    this.loadConf();
    this.$store
      .dispatch("Configuration/loadBillingCycles", {
        axios: this.$axios,
        pid: sessionStorage.getItem("pid"),
      })
      .then(() => {
        this.recalcPrices();
      });
  },
  computed: {
    billing: {
      get() {
        return this.$store.state.Choices.billing;
      },
      set(val) {
        this.$store.commit("Choices/SET_BILLING", val);
      },
    },
    currency() {
      return this.$store.state.Configuration.currency;
    },
    rules() {
      return rules;
    },

    billinglist() {
      return this.$store.state.Configuration.billingcyclelist;
    },
    packages: {
      get() {
        return this.$store.state.Choices.package;
      },
      set(val) {
        this.$store.commit("Choices/SET_PACKAGE", val);
      },
    },
    ipversion: {
      get() {
        return this.$store.state.Choices.ipversion;
      },
      set(val) {
        this.$store.commit("Choices/SET_IPVERSION", val);
      },
    },
    country: {
      get() {
        return this.$store.state.Choices.country;
      },
      set(val) {
        this.$store.commit("Choices/SET_COUNTRY", val);
      },
    },
    isp: {
      get() {
        return this.$store.state.Choices.isp;
      },
      set(val) {
        this.$store.commit("Choices/SET_ISP", val);
      },
    },
    protocol: {
      get() {
        return this.$store.state.Choices.protocol;
      },
      set(val) {
        this.$store.commit("Choices/SET_PROTOCOL", val);
      },
    },
    authtype: {
      get() {
        return this.$store.state.Choices.authtype;
      },
      set(val) {
        this.$store.commit("Choices/SET_AUTHTYPE", val);
      },
    },
    bandwidth: {
      get() {
        return this.$store.state.Choices.bandwidth;
      },
      set(val) {
        this.$store.commit("Choices/SET_BW", val);
      },
    },
    // ipversionlist()
    // {
    //   return this.$store.state.IPVersion.ipversionlist
    // },
    ipversionlist() {
      return this.$store.state.IPVersion.ipversionlist;
    },
    countrylist() {
      let items = [];
      const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
      this.$store.state.Configuration?.orderconfiguration?.supportedCountries?.map(
        (i) => items.push({ text: regionNames.of(i.code), value: i.code })
      );
      return items;
    },
    orderconfiguration() {
      return this.$store.state.Configuration?.orderconfiguration;
    },
    isplist() {
      let items = [];
      if (this.country && this.orderconfiguration.supportedISPs[this.country]) {
        for (const key in this.orderconfiguration.supportedISPs[this.country]) {
          items.push({
            text: this.orderconfiguration.supportedISPs[this.country][key].name,
            value: key,
          });
        }
      }
      return items;
    },
    authlist() {
      let items = [];
      this.$store.state.Configuration.orderconfiguration?.supportedAuthenticationTypes?.map(
        (i) => items.push({ text: LangMap(i), value: i })
      );
      return items;
    },
    supportedProtocols() {
      return this.$store.state.Configuration.orderconfiguration
        .supportedProtocols;
    },
    packagelist() {
      return this.$store.state.Configuration.orderconfiguration
        .supportedPackages;
    },
    supportedIPWhitelistCount() {
      return this.$store.state.Configuration?.orderconfiguration
        ?.supportedIpWhitelistCount;
    },
  },
};
</script>